export default __webpack_public_path__ + "static/media/to_delete8.670c3f7a.png";